import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllAtmedHelpSupportLab,
  updateAtmedHelpSupportLab
} from '../../../store/actions';
import HelpSupport from './help';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  results: vendorEquipmenReducer.results,
  updateResult: vendorEquipmenReducer.updateResult,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllAtmedHelpSupportLab,
    updateAtmedHelpSupportLab
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(HelpSupport);
